var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"mb-5"},[_c('NavBar')],1),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('Home')],1),_c('div',{staticClass:"column is-10"},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }